// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"134":"app-messages-Spanish_Ext","147":"app-messages-ChineseWu_Ext","294":"app-messages-en_US","586":"product-metadata"}[chunkId] || chunkId) + "." + {"134":"9848a5aa","147":"14e77a58","294":"e6ceb260","586":"b700844d","626":"d193ad66"}[chunkId] + ".chunk.js";
};